module.exports = __webpack_public_path__ + "img/message.2b93d0b5.png";